module.exports = __webpack_public_path__ + "img/welcome-page-img1.07e2ec8a.svg";